<template>
  <div class="register-container">
    <a-card title="注册" class="register-card">
      <a-form
          name="register"
          :model="formState"
          @finish="onFinish"
          @finishFailed="onFinishFailed"
      >
        <a-form-item
            label="用户名"
            name="username"
            :rules="[{ required: true, message: '请输入用户名!' }]"
        >
          <a-input v-model:value="formState.username" placeholder="用户名" />
        </a-form-item>
        <a-form-item
            label="手机号"
            name="phone"
            :rules="[{ required: true, message: '请输入手机号!' }]"
        >
          <a-input v-model:value="formState.phone" placeholder="手机号" />
        </a-form-item>
        <a-form-item
            label="密码"
            name="password"
            :rules="[{ required: true, message: '请输入密码!' },
            { min: 8, message: '密码长度不能少于8位'}]"
        >
          <a-input-password v-model:value="formState.password" placeholder="密码" />
        </a-form-item>

        <a-form-item
            label="确认密码"
            name="confirmPassword"
            :rules="[
              { required: true, message:'请再次输入密码！'},
              { validator: validateConfirm }
            ]"
        >
          <a-input-password v-model:value="formState.confirmPassword" placeholder="确认密码" />
        </a-form-item>

        <a-form-item
            label="头像"
            name="avatar"
        >
          <a-upload
              list-type="picture-card"
              :show-upload-list="false"
              :before-upload="beforeUpload"
          >
            <img
                v-if="imageUrl"
                :src="imageUrl"
                alt="avatar"
                style="width: 100%"
            />

            <div v-else>
              <plus-outlined />
              <div style="margin-top: 8px">上传</div>
            </div>
          </a-upload>
        </a-form-item>

        <a-form-item
            label="个性签名"
            name="signature"
        >
          <a-textarea v-model:value="formState.signature" placeholder="个性签名" />
        </a-form-item>

        <a-form-item>
          <div id="link-container">
            <router-link to="/login" id="enter-backend">已有账号？去登录...</router-link>
          </div>
          <a-button type="primary" html-type="submit" block>
            注册
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script setup>
import { ref,reactive } from "vue"
import { message } from "ant-design-vue"
import { PlusOutlined } from '@ant-design/icons-vue'
import request from "@/utils/request.js";
import router from "@/router/index"
const formState = reactive({
  username: "",
  phone:"",
  password: "",
  confirmPassword: "",
  avatar: "",
  signature: ""
})
const validateConfirm = (_, value) => {
  if (!value) {
    return Promise.reject()
  }
  if (value !== formState.password) {
    return Promise.reject("两次输入的密码不一致")
  }
  return Promise.resolve()
}

const imageUrl = ref('')

const beforeUpload = (file) => {
  const isImage = file.type.startsWith('image/')
  if (!isImage) {
    message.error('只能上传图片文件！')
    return false
  }

  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isLt2M) {
    message.error('图片必须小于 2MB！')
    return false
  }

  const reader = new FileReader()
  reader.onload = (e) => {
    imageUrl.value = e.target.result
    formState.avatar = file
  }
  reader.readAsDataURL(file)

  return false
}
const onFinishFailed=()=>{
  message.error("请填写完整信息！");
}
const onFinish=async ()=>{
  try{
    const formData=new FormData()
    formData.append("username",formState.username)
    formData.append("phone",formState.phone)
    formData.append("password",formState.password)
    formData.append("signature",formState.signature)
    formData.append("avatar",formState.avatar)
    await request.post("/auth/register",formData)
    await router.replace("/login");
    message.success("注册成功！")
  } catch (err)
  {
    message.error(err.response.data)
  }

}

</script>

<style scoped>
.register-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(120deg, #1890ff, #87cefa);
}

.register-card {
  width: 450px;
  border-radius: 10px;
}
#link-container{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>